module.exports = __webpack_public_path__ + "img/logo-white.45097a57.svg";